import { Component, HostListener, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { filter, firstValueFrom } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { OptionWindow } from 'src/app/enum/option-window-enums';
import { ProfileUserEnums } from 'src/app/enum/profile-user-enums';
import { WindowEnums } from 'src/app/enum/window-enums';
import { TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { MaintenanceOrderTableModel } from 'src/app/models/maintenance/maintenance-order-table.model';
import { RepairTableModel } from 'src/app/models/maintenance/repair-table.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { MaintenanceOrderService } from 'src/app/services/maintenance/maintenance-order.service';
import { RepairService } from 'src/app/services/maintenance/repair.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-maintenance-order',
  templateUrl: './maintenance-order.component.html',
  styleUrls: ['./maintenance-order.component.scss'],
  standalone: false
})
export class MaintenanceOrderComponent implements OnInit {

  activeTabIndex = 0;
  ascendant: boolean = true;
  columnSort: string | null = null;
  filters: ColumnResponseModel[] = [];
  generalData: PagedResponseModel<MaintenanceOrderTableModel> = new PagedResponseModel<MaintenanceOrderTableModel>();
  generalHeader: ColumnResponseModel[] = [];
  isOpened: string | undefined = undefined;
  nameWindow: string = 'Ordenes de Mantenimiento';
  permissionUpdatable: boolean = false;
  permissionsUser: Array<OptionWindowModel> = new Array<OptionWindowModel>();
  projectName = ProjectName.projectName;
  repairData: PagedResponseModel<RepairTableModel> = new PagedResponseModel<RepairTableModel>();
  repairHeader: ColumnResponseModel[] = [];
  limit: number = 10;
  page: number = 1;
  previousSort: { field: string; isAscsendant: number };
  tableActions: TableAction[] = [
    {
      label: 'Editar',
      icon: 'pi pi-pencil',
      action: 'edit'
    },
  ];
  url: string = "";
  userAuthenticated: UserModel = new UserModel();

  constructor(private headerService: HeaderService,
    private maintenanceOrderService: MaintenanceOrderService,
    private optionWindowService: OptionWindowService,
    private repairService: RepairService,
    private router: Router,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService) {
    this.getPermission();
  }

  async ngOnInit() {
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.headerService.setTitle(this.nameWindow);
    const filters = localStorage.getItem('maintenance-order');
    if (filters) this.filters = JSON.parse(filters);
    await Promise.all([
      this.getColumnsForGeneralConsultation(),
      this.getMaintenanceOrdersWithPagination(),
    ]);
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  async exportGeneralConsultation() {
    if (this.userAuthenticated.profileUser.code == ProfileUserEnums.administrador || this.permissionsUser.find(x => x.code == OptionWindow.Exportar)) {
      try {
        const response = await firstValueFrom(this.maintenanceOrderService.exportGeneralConsultation(this.filters, this.columnSort, this.ascendant));
        const blob = response;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Ordenes de Mantenimiento.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error al exportar las ordenes de mantenimiento.', error);
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para exportar Ordenes de Mantenimiento, comuniquese con el administrador del sistema.'
      );
    }
  }

  async exportRepairsConsultation() {
    if (this.userAuthenticated.profileUser.code == ProfileUserEnums.administrador || this.permissionsUser.find(x => x.code == OptionWindow.Exportar)) {
      try {
        const response = await firstValueFrom(this.repairService.exportGeneralConsultation(this.filters, this.columnSort, this.ascendant));
        const blob = response;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Reparaciones.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error al exportar las reparaciones.', error);
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para exportar Reparaciones, comuniquese con el administrador del sistema.'
      );
    }
  }

  async getColumnsForGeneralConsultation() {
    try {
      if (this.generalHeader.length === 0) {
        this.generalHeader = await firstValueFrom(this.maintenanceOrderService.getColumnsForGeneralConsultation());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta general.', error);
    }
  }

  async getColumnsForRepairsConsultation() {
    try {
      if (this.repairHeader.length === 0) {
        this.repairHeader = await firstValueFrom(this.repairService.getColumnsForGeneralConsultation());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta de reparaciones.', error);
    }
  }

  async getMaintenanceOrdersWithPagination() {
    try {
      this.generalData = await firstValueFrom(this.maintenanceOrderService.getAllMaintenanceOrdersWithPagination(this.page, this.limit, this.columnSort, this.ascendant, this.filters));
    } catch (error) {
      console.error('Error al buscar las ordenes de mantenimiento.', error);
    }
  } async getPermission() {
    let url = this.router.url as string
    url = url.substring(1);
    this.url = url;
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'error',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error(error);
    }
    this.getPermissionsForUserByWindow();
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(
      this.userAuthenticatedService.userObservable.pipe(
        filter(user => user && user.userId !== 0)
      )
    );
    this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.MaintenanceOrder));
  }

  async getRepairsWithPagination() {
    try {
      this.repairData = await firstValueFrom(this.repairService.getRepairsWithPagination(this.page, this.limit, this.columnSort, this.ascendant, this.filters));
    } catch (error) {
      console.error('Error al buscar las reparaciones de los articulos.', error);
    }
  }

  goToHome(event: Event) {
    event.preventDefault();
    this.router.navigate(['/main']);
  }

  public async handleTabChange(tabIndex: number) {
    this.generalHeader.length = this.generalHeader.length === 1 ? 0 : this.generalHeader.length;
    this.repairHeader.length = this.repairHeader.length === 1 ? 0 : this.repairHeader.length;

    if (this.activeTabIndex === tabIndex) return;

    this.page = 1;
    this.limit = 10;
    this.activeTabIndex = tabIndex;

    switch (this.activeTabIndex) {
      case 0:
        await Promise.all([
          this.getColumnsForGeneralConsultation(),
          this.getMaintenanceOrdersWithPagination()
        ]);
        this.generalData = {
          ...this.generalData,
          currentPage: 1,
          pageSize: 10
        };
        break;
      case 1:
        await Promise.all([
          this.getColumnsForRepairsConsultation(),
          this.getRepairsWithPagination()
        ]);
        this.repairData = {
          ...this.repairData,
          currentPage: 1,
          pageSize: 10
        };
        break;
    }
  }

  newMaintenanceOrder() {
    if (this.permissionUpdatable) {
      this.router.navigate(['/maintenance-order/register']);
    } else {
      this.toastHandlerService.showToast(
        'error',
        'El usuario no tiene permisos para crear ordenes de mantenimiento, comuniquese con el administrador del sistema.'
      );
    }
  }

  onAction(event: { action: string, item?: MaintenanceOrderTableModel, selectedItems?: number[] }) {
    if (event.action === 'edit' && event.item) {
      this.router.navigate([`/maintenance-order/register/${event.item.id}`]);
    }
  }

  async onExport() {
    switch (this.activeTabIndex) {
      case 0:
        await this.exportGeneralConsultation();
        break;
      case 1:
        await this.exportRepairsConsultation();
        break;
    }
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters.map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index).map((item: any) => item.value);
    this.filters = this.removeDuplicates(filters);
    // Procesar cada filtro
    this.filters.forEach((filter: any) => this.processFilter(filter));
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    switch (this.activeTabIndex) {
      case 0:
        await this.getMaintenanceOrdersWithPagination()
        break;
      case 1:
        await this.getRepairsWithPagination()
        break;
    }
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filters = this.filters.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filters.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  reloadWindow(event: Event) {
    event.preventDefault();
    this.router.navigate(['/maintenance-order']);
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

}
